import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SearchFacetTitle } from './SearchFacetLib';
import styles from './common_section.module.scss';

type Props = {
  title: string;
};

export const CommonSection: FC<Props> = ({ children, title }) => (
  <div className={styles.container}>
    <SearchFacetTitle>
      <FormattedMessage id={title} />
    </SearchFacetTitle>
    <div>{children}</div>
  </div>
);
